module.exports = __webpack_public_path__ + "img/partner-hover-3.f49e8e15.png";